/*参观服务-子路由*/
export default [
  {
    path: '/service/activity_yy/list',
    name: 'activity_yy',
    component: resolve => require(['@/components/service/activity_yy/list.vue'], resolve),
    meta: {
      title: '活动预约'
    }
  },
  {
    path: '/service/yaoyiyao',
    name: 'yaoyiyao',
    component: resolve => require(['@/components/service/yaoyiyao/index.vue'], resolve),
    meta: {
      title: '摇一摇'
    }
  },
  {
    path: '/service/interaction',
    name: 'interaction',
    redirect: '/service/interaction/questionnaire',
    component: resolve => require(['@/components/service/interaction/index.vue'], resolve),
    meta: {
      title: '互动'
    },
    children: [
      {
        path: '/service/interaction/opinion',
        name: 'opinion',
        component: resolve => require(['@/components/service/interaction/opinion.vue'], resolve),
        meta: {
          title: '意见反馈'
        }
      },
      {
        path: '/service/interaction/questionnaire',
        name: 'questionnaire',
        component: resolve => require(['@/components/service/interaction/questionnaire.vue'], resolve),
        meta: {
          title: '问卷调查'
        }
      },
      {
        path: '/service/interaction/questionAnswering',
        name: 'questionAnswering',
        component: resolve => require(['@/components/service/interaction/questionAnswering.vue'], resolve),
        meta: {
          title: '知识问答',
        }
      },
      {
        path: '/service/interaction/questionDet/:knowledge_id',
        name: 'questionDet',
        component: resolve => require(['@/components/service/interaction/questionDet.vue'], resolve),
        meta: {
          title: '知识问答详情',
        }
      },
      {
        path: '/service/interaction/historyStory',
        name: 'order_date',
        component: resolve => require(['@/components/service/interaction/historyStory.vue'], resolve),
        meta: {
          title: '历史故事',
        }
      }
    ]
  }
]


// WEBPACK FOOTER //
// ./src/router/service/index.js